<template>
  <v-dialog v-model="dialog" scrollable width="850">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Tạo phiếu Xuất / Nhập / Luân chuyển kho</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4">
        <TransactionForm ref="transactionForm" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="save">LẬP PHIẾU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TransactionForm from '@/modules/facility/transaction/TransactionForm.vue'
import { mapActions } from 'vuex'

export default {
  name: 'TransactionNewDialog',
  components: { TransactionForm },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false
    }
  },
  watch: {
    state(val) {
      if (val) this.dialog = true
    }
  },
  methods: {
    ...mapActions('FacilityTransactions', ['createTransaction']),
    cancel() {
      this.dialog = false
      if (this.$refs.transactionForm) {
        this.$refs.transactionForm.resetValidation()
      }
    },
    async save() {
      if (!this.$refs.transactionForm.validate()) return

      this.$loading.active = true
      try {
        const payload = this.$refs.transactionForm.getData()
        await this.createTransaction(payload)
        this.dialog = false
        this.$emit('updated')
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
